import React, { useEffect, useState } from "react";
import classNames from "../../classNames";

const noop = () => {};
const defaultProps = {
  type: "text",
  strict: false,
  onChange: noop,
};

function Parse({
  percent,
  className,
  _type,
  type,
  strict,
  onChange,
  uppercase,
  defaultValue: initialValue,
  ...props
}) {
  const [value, setValue] = useState("");

  const formatNumber = (inputValue) => {
    // Remove currency and thousands separators
    let value = inputValue.replace(/[₱, ]/g, "");

    // Split into integer and decimal parts
    const [integerPart, decimalPart] = value.split(".");

    // Format the integer part with commas
    const formattedIntegerPart = integerPart.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      ","
    );

    // If there's a decimal part, append it as is
    return decimalPart !== undefined
      ? `₱ ${formattedIntegerPart}.${decimalPart}`
      : `₱ ${formattedIntegerPart}`;
  };

  useEffect(() => {
    if (initialValue) {
      const formattedValue = formatNumber(initialValue.toString());
      setValue(formattedValue);
    }
  }, [initialValue]);

  function onInput(e) {
    let inputValue = e.target.value;

    // Allow numeric characters and a single decimal point
    inputValue = inputValue.replace(/[^0-9.]/g, "");

    // Ensure only one decimal point is allowed
    const parts = inputValue.split(".");
    if (parts.length > 2) {
      inputValue = parts[0] + "." + parts.slice(1).join("");
    } else {
      inputValue = parts.join(".");
    }

    // Format the number
    const formattedValue = formatNumber(inputValue);

    setValue(formattedValue);
    e.target.value = formattedValue;

    onChange(percent === "percent" ? formattedValue + "%" : formattedValue);
  }

  return (
    <div>
      <input
        className={classNames("form-control", className)}
        value={value}
        onInput={onInput}
        {...props}
      />
      <br />
    </div>
  );
}

Parse.defaultProps = defaultProps;
export default Parse;
